import { Typography, Link } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Subscription } from "@appTypes/index";
import { SUBSCRIPTION_SOURCES } from "@constants/subscriptions";

const appleSubscriptionLink = "https://support.apple.com/en-us/HT202039";
const googleSubscriptionLink = "https://play.google.com/store/account/subscriptions";

interface MobileSourceHelperTextProps {
  source: Subscription["source"];
}

const MobileSourceHelperText = ({ source }: MobileSourceHelperTextProps) => {
  const { t } = useTranslation();

  if (source === SUBSCRIPTION_SOURCES.APPLE) {
    return (
      <Typography variant="body2" color="text.secondary" className="mt-1">
        {t("Your subscription is managed through Apple.")}{" "}
        <Link href={appleSubscriptionLink} target="_blank" rel="noopener noreferrer">
          {t("To make changes")}
        </Link>
        {", "}{t("please visit your Apple ID Settings.")}
      </Typography>
    );
  }

  if (source === SUBSCRIPTION_SOURCES.GOOGLE) {
    return (
      <Typography variant="body2" color="text.secondary" className="mt-1">
        {t("Your subscription is managed through Google.")}{" "}
        <Link href={googleSubscriptionLink} target="_blank" rel="noopener noreferrer">
          {t("To make changes")}
        </Link>
        {", "}{t("please visit your Google Play subscriptions.")}
      </Typography>
    );
  }

  return null;
};

export default MobileSourceHelperText;
